















import { defineComponent } from '@vue/composition-api'
import { useShapes, useSizes, useThemes } from '../../compositions'
import { KisweShape, KisweSize, KisweTheme } from '../../types'
import { KisweButton } from '../KisweButton'
import KisweIcon from '../KisweIcon'

export default defineComponent({
  name: 'KisweButtonFullscreen',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    elementSelector: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useThemes({ theme: KisweTheme.Tertiary }).props,
    ...useShapes({ shape: KisweShape.Square }).props,
    ...useSizes({ size: KisweSize.Small }).props
  },
  methods: {
    goFullScreen () {
      const element = document.querySelector(this.elementSelector)
      if (element) {
        element.requestFullscreen({ navigationUI: 'hide' }).catch((error) => {
          console.error(`Error attempting to enter full screen mode. Element: ${element}`, error)
          this.$message.error('Failed to enter full screen mode')
        })
      } else {
        console.error(`No element found to show in full screen. Element selector: ${this.elementSelector}`)
      }
    }
  }
})
